import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { cards } from 'sections/Benefits/BrandReliability/data';
import useWindowSize from 'utils/hooks/useWindowSize';
import Card from 'sections/Benefits/components/Card';
import styles from 'styles/pages/Benefits/BrandReliability/BrandReliability.module.scss';

const cn = classNames.bind(styles);

const SectionCards = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  const cardsList = cards.map((card) => {
    return (
      <Card className={cn('card-item')} key={card.icon}>
        <div className={cn('card-item__content')}>
          <Card.Header className={cn('card-item__title-box')}>
            <div className={cn('card-item__icon')}>
              <img src={`/images/pages/Benefits/${card.icon}`} alt={card.alt} />
            </div>
            <h3 className={cn('card-item__title')}>{card.title}</h3>
          </Card.Header>  
          <Card.Content className={cn('card-item__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('cards')}>
      <div className={cn('container')}>
        <div className={cn('cards__title-box')}>
          <h2 className={cn('cards__title')}>
            Unlock the Power of a Reliable Brand
          </h2>
          {screenWidth >= 576
            ?
            <p className={cn('cards__title-description')}>
              <span>Enhance trust, build stronger relationships, and gain</span> 
              <span>a competitive edge in freight forwarding</span>
            </p>
            :
            <p className={cn('cards__title-description')}>
              Enhance trust, build stronger relationships, and gain 
              a competitive edge in freight forwarding 
            </p>
          }
        </div>
        <ul className={cn('cards__list')}>
          {cardsList}
        </ul>
      </div>
    </section>
  );
};

export default SectionCards;